import { Link, useLocation, useParams } from "react-router-dom"
import styles from "./style.module.css"
import Typography from "../../components/Typography/Typography"
import { productImg, storeImg } from "../../assets/images"
import { RateStars } from "../../components/RateStar"
import { InputField } from "../../components/InputField"
import { useState } from "react"
import FlatButtons from "../../components/FlatButton/FlatButton"
import { Toast } from "../../components/ToastComponent"

export const BuyerRatePage: React.FC = () => {

    const [review, setReview] = useState("")
    const [reviewDetail, setReviewDetail] = useState("")
    const [name, setName] = useState("")
    const [initialRate, setInitialRate] = useState(1)
    const [rateModal, setRateModal] = useState(false)

    const location = useLocation();
    const fromRateStore = location.state?.fromRateProductStore ?? false;


    const handleReview = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setReview(e.target.value)
    }

    const handleReviewDetail = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setReviewDetail(e.target.value)
    }

    const handleName = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setName(e.target.value)
    }

    const { id } = useParams()
    console.log(id)

    return (
        <div className={styles.container}>

            <div className={styles.subContainer}>

                <Link className={styles.headerLink} to={"/buyer-review"}>
                    <div className={styles.headerContainer}>

                        <div className={styles.arrowContainer}>
                            <div className={styles.arrow}></div>
                        </div>

                        <div>
                            <Typography
                                variant="heading5"
                                className={styles.heavyText}
                            >
                                Rate and Review
                            </Typography>
                        </div>

                    </div>
                </Link>

                <div className={styles.instructionContainer}>

                    <Typography
                        variant="heading5"
                        className={styles.heavyText}
                    >
                        Use stars to leave a rating
                    </Typography>

                </div>

                <div className={styles.reviewWrap}>

                    <div className={styles.imgContainer}>

                        {fromRateStore ? (
                            <img className={styles.img} src={storeImg} alt="" />

                        ) : (
                            <img className={styles.img} src={productImg} alt="" />
                        )}

                    </div>

                    <div>
                        <div>

                            {fromRateStore ? (
                                <Typography
                                    variant="heading5"
                                    className={styles.heavyText}
                                >
                                    Akado Children’s Store
                                </Typography>
                            ) : (
                                <Typography
                                    variant="heading5"
                                    className={styles.heavyText}
                                >
                                    Crew Neck Long Sleeve Shirt
                                </Typography>
                            )}

                        </div>
                        <div className={styles.starContainer}>
                            <div>
                                <RateStars
                                    totalStars={5}
                                    initialRating={initialRate}
                                    onChange={(rating) => {
                                        console.log("User selected:", rating)
                                        setInitialRate(rating)
                                    }}
                                />
                            </div>
                            <div className={styles.pickStar}>
                                <Typography
                                    variant="heading5"
                                    className={styles.heavyText}
                                >
                                    (Pick a star)
                                </Typography>
                            </div>
                        </div>
                    </div>

                </div>

                <div className={styles.leaveReviewContainer}>

                    <div>
                        {fromRateStore ? (
                            <Typography
                                variant="heading5"
                                className={styles.heavyText}
                            >
                                Leave a Review of this store
                            </Typography>
                        ) : (
                            <Typography
                                variant="heading5"
                                className={styles.heavyText}
                            >
                                Leave a Review of this product
                            </Typography>
                        )}
                    </div>
                    <div className={styles.reviewContainer}>
                        <div className={styles.reviewField}>
                            <InputField
                                title="Review this"
                                value={review}
                                onChange={handleReview}
                                placeHolder="eg. I like it/I don’t like it"
                            />
                        </div>
                        <div className={styles.reviewField}>
                            <InputField
                                title="Name"
                                value={name}
                                onChange={handleName}
                            // placeHolder="eg. I like it/I don’t like it"
                            />
                        </div>
                    </div>
                    <div>
                        <InputField
                            title="Review Details"
                            value={reviewDetail}
                            onChange={handleReviewDetail}
                            multiLine={true}
                        />
                    </div>


                </div>

                <div className={styles.submitBtnContainer}>

                    <FlatButtons
                        onClick={() => { setRateModal(!rateModal) }}
                        className={styles.submitBtn}
                    >

                        <Typography>
                            Submit Your Review
                        </Typography>

                    </FlatButtons>

                </div>

                <Toast openModal={rateModal} toggle={() => { setRateModal(!rateModal) }} >

                    <div className={styles.reviewContent}>

                        <div className={styles.reviewText}>
                            <Typography
                                variant="heading5"
                                className={styles.heavyText}
                            >
                                Review
                            </Typography>
                        </div>

                        <div className={styles.reviewText}>
                            <Typography>
                                Your Review and rating has been sucessfully submitted
                            </Typography>
                        </div>

                    </div>

                </Toast>

            </div>

        </div >
    )
}